var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-survey__inner c-survey__bg--yellow" }, [
    _vm.settings.prizeDrawEnabled
      ? _c("div", { staticClass: "c-survey__bar c-survey__bg--blue" }, [
          _c("div", { staticClass: "c-survey__bar-inner" }, [
            _c("h1", { staticClass: "white-text" }, [
              _vm._v(
                _vm._s(_vm.thankyou.preCode) +
                  " " +
                  _vm._s(_vm.submissionData.prizeDrawCode)
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "c-survey__content c-survey__content--padding c-survey__content--white-bg",
      },
      [
        _c("div", { staticClass: "c-survey__grid c-survey__grid--results" }, [
          _c("div", { staticClass: "c-survey__results-wrapper" }, [
            _c("main", {
              staticClass: "c-survey__html",
              domProps: { innerHTML: _vm._s(_vm.results.content) },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "c-survey__grid c-survey__grid--results-choices" },
              [
                _c("div", { staticClass: "c-survey__results-total-wrapper" }, [
                  _c("div", { staticClass: "c-survey__results-total-circle" }, [
                    _c("h1", [_vm._v(_vm._s(_vm.resultsData.totalTokens))]),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("Pie", {
                      attrs: {
                        data: _vm.getChartDataChartOne.chartData,
                        options: _vm.getChartDataChartOne.chartOptions,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("main", {
              staticClass: "c-survey__html",
              domProps: { innerHTML: _vm._s(_vm.results.questionContent) },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "c-survey__grid c-survey__grid--results-choices" },
              [
                _c("div", { staticClass: "c-survey__results-total-wrapper" }, [
                  _c("div", { staticClass: "c-survey__results-total-circle" }, [
                    _c("h1", [_vm._v(_vm._s(_vm.resultsData.totalResponses))]),
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("Pie", {
                      attrs: {
                        data: _vm.getChartDataChartTwo.chartData,
                        options: _vm.getChartDataChartTwo.chartOptions,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-survey__results-animation" },
            [
              _c("lottie-vue-player", {
                attrs: {
                  src: _vm.results.animationFile,
                  "player-controls": false,
                  loop: true,
                  autoplay: true,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "c-survey__actionbutton-row c-survey__actionbutton-row--right",
          },
          [
            _c("ActionButton", {
              attrs: { title: _vm.results.restartLabel, buttonAction: "reset" },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", [_vm._v("total tokens"), _c("br"), _vm._v("spent")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", [_vm._v("total"), _c("br"), _vm._v("responses")])
  },
]
render._withStripped = true

export { render, staticRenderFns }